import { useContext, useMemo } from 'react';
import { AppContext } from '@/context/AppContext';
import { MapPin } from 'lucide-react';

export default function CityTabs() {
  const { rankings, activeClientId, activeCityFilter, setActiveCityFilter } = useContext(AppContext);

  const cities = useMemo(() => {
    const clientRankings = rankings[activeClientId] || [];
    const unique = [...new Set(clientRankings.map(r => r.location))].sort();
    return ['all', ...unique];
  }, [rankings, activeClientId]);

  if (cities.length <= 2) return null;

  return (
    <div className="grid grid-cols-2 sm:flex sm:flex-wrap gap-2" data-testid="city-tabs">
      {cities.map(city => (
        <button
          key={city}
          onClick={() => setActiveCityFilter(city)}
          className={`flex items-center justify-center gap-1.5 sm:gap-2 px-3 sm:px-4 py-2 sm:py-2 rounded-lg font-syne text-xs sm:text-sm font-semibold transition-all whitespace-nowrap ${
            activeCityFilter === city
              ? 'bg-[#1A2338] text-[#E2E8F0] border border-[#0070F3]'
              : 'text-[#94A3B8] hover:text-[#E2E8F0] border border-[#1E2D45] hover:border-[#2A3A5E]'
          }`}
          data-testid={`city-tab-${city === 'all' ? 'all' : city.replace(/\s/g, '-')}`}
        >
          {city === 'all' ? (
            <>All Markets</>
          ) : (
            <>
              <MapPin size={12} className="sm:w-3.5 sm:h-3.5" />
              {city}
            </>
          )}
        </button>
      ))}
    </div>
  );
}
